 
import React, { ReactElement } from 'react';

import { SkeletonBase } from '@digital-dealer/components';

const DesktopSkeleton = (): ReactElement => (
  <SkeletonBase viewBox="0 0 1200 780">
    <rect
      y="82"
      width="793"
      height="453"
      rx="4"
    />
    <rect
      y="551"
      width="192.25"
      height="64"
    />
    <rect
      x="200.25"
      y="551"
      width="192.25"
      height="64"
    />
    <rect
      x="400.5"
      y="551"
      width="192.25"
      height="64"
    />
    <rect
      x="600.75"
      y="551"
      width="192.25"
      height="64"
    />
    <rect
      y="42"
      width="372"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="42"
      width="160"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="100"
      width="101"
      height="18"
      rx="4"
    />
    <rect
      x="813"
      y="74"
      width="387"
      height="18"
      rx="4"
    />
    <rect
      x="1146"
      y="42"
      width="54"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="166"
      width="160"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="224"
      width="101"
      height="18"
      rx="4"
    />
    <rect
      x="813"
      y="198"
      width="387"
      height="18"
      rx="4"
    />
    <rect
      x="1146"
      y="166"
      width="54"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="290"
      width="160"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="348"
      width="101"
      height="18"
      rx="4"
    />
    <rect
      x="813"
      y="322"
      width="387"
      height="18"
      rx="4"
    />
    <rect
      x="1146"
      y="290"
      width="54"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="414"
      width="160"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="472"
      width="101"
      height="18"
      rx="4"
    />
    <rect
      x="813"
      y="446"
      width="387"
      height="18"
      rx="4"
    />
    <rect
      x="1146"
      y="414"
      width="54"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="538"
      width="160"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="596"
      width="101"
      height="18"
      rx="4"
    />
    <rect
      x="813"
      y="570"
      width="387"
      height="18"
      rx="4"
    />
    <rect
      x="1146"
      y="538"
      width="54"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="662"
      width="160"
      height="24"
      rx="4"
    />
    <rect
      x="813"
      y="720"
      width="101"
      height="18"
      rx="4"
    />
    <rect
      x="813"
      y="694"
      width="387"
      height="18"
      rx="4"
    />
    <rect
      x="1146"
      y="662"
      width="54"
      height="24"
      rx="4"
    />
  </SkeletonBase>
);

export default DesktopSkeleton;
